export default {
  main: {
    'ciders-and-spirits': 'Cidres',
    'high-altitude': 'Haute altitude',
    'savoir-faire': 'Savoir-faire',
    contacts: 'Contacts',
    info: 'Ristorante da Guido <br>Via Roma Sinistra, 25 <br>30016 Jesolo Paese (Venise) <br>Tél. <a class="link-underline-reverse-1" href="tel:+39 0421 350380">+39 0421 350380</a> <br>TVA 03205420270',
    extra:
      'Fermé le lundi et le mardi midi. <br>L’accès aux animaux n’est pas autorisé <br>sauf pour les chiens accompagnant <br>des personnes en situation de handicap.',
    'book-online': 'Formulaire en ligne',
    'book-tel':
      'Tél : <a class="link-underline-reverse-1" href="tel:+39 0421 350380">+39 0421 350380</a>',
    social: 'Réseaux sociaux',
    instagram:
      '<a class="link-underline-reverse-1" href="https://www.instagram.com/daguidojesolo/" rel="noopener" target="_blank">Instagram</a>',
    facebook:
      '<a class="link-underline-reverse-1" href="https://www.facebook.com/daguidojesolo/" rel="noopener" target="_blank">Facebook</a>',
    knowUs:
      'Faisons connaissance : ensemble, nous pouvons aller plus loin que vous ne l’imaginez.',
    discover:
      'Découvrez les postes ouverts pour mettre votre talent à l’épreuve.',
    newsletter: 'Découvrez ce qui se cache derrière la magie de Bluemotion.',
    emailField: 'Email',
    newsletterCaption:
      'Conformément au Règlement UE 2016/679 - RGPD, je consens au traitement de mes données personnelles comme indiqué dans <a href="/fr/privacy-policy" class="link-underline-1">la politique de confidentialité</a>',
    newsletterError:
      'Veuillez accepter le traitement des données conformément au RGPD',
    corporate:
      '<strong>Bluemotion Srl</strong> Viale del Lavoro 14, int 34, 35020 Ponte San Nicolò, Padoue TVA 03897210286',
    associated: 'Nous sommes membres',
    copyright: '© {year} - Proposta Vini',
    privacy: 'Politique de confidentialité',
    inviaRichiesta: 'Envoyer une demande',
  },
}
